"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getSelectedTheme = _interopRequireDefault(require("./utils/getSelectedTheme"));

var _initializeSelectedTheme = _interopRequireDefault(require("./utils/initializeSelectedTheme"));

var _getThemeFromRegistry = _interopRequireDefault(require("./utils/getThemeFromRegistry"));

var _initializeThemeRegistry = _interopRequireDefault(require("./utils/initializeThemeRegistry"));

var _mergeRegistry = _interopRequireDefault(require("./utils/mergeRegistry"));

var _setSelectedTheme = _interopRequireDefault(require("./utils/setSelectedTheme"));

var _cxThemeInfo = require("../CxStyleDictionary/themes/cxThemeInfo");

var _cxObserver = _interopRequireDefault(require("../cxObserver/cxObserver"));

var _gtag = _interopRequireDefault(require("../cxObserver/gtag"));

/* eslint-disable camelcase */
var propTypes = {
  /**
   * The component(s) that will be wrapped by `<CxThemeProvider />`
   */
  children: _propTypes.default.node,

  /**
   * Load CX Styles Last.  If this property is true then the Cx Styles will be loaded at the end of the header section.
   * In this case the CX Styles will potentially override any custom styles.
   * A value of true will also preserves the behavior from version prior to CX5
   */
  loadCxStylesLast: _propTypes.default.bool,

  /**
   * The name of the theme to set.
   */
  themeName: _propTypes.default.string,

  /**
   * The list of themes to add to the registry.
   */
  themeRegistries: _propTypes.default.arrayOf(_propTypes.default.object)
};
/**
 * Provides the CX theme.  If the provided theme name is in the registry it will be loaded.
 * @param {string}          themeName           The theme name to use.  If the name is not in the registry then
 * @param {object[]}        themeRegistries     The list of theme registries to use
 * @param {node[]}          children            The child nodes to render
 * @param {boolean}         loadCxStylesLast    If true the cx styles are loaded last
 * @returns {JSX.Element}
 * @constructor
 */

/** The CxThemeProvider provides the theme CSS to the application.  It will inject the CX Theme CSS into the
 <head> section of the DOM
 */

var CxThemeProvider = function CxThemeProvider(_ref) {
  var themeName = _ref.themeName,
      themeRegistries = _ref.themeRegistries,
      children = _ref.children,
      loadCxStylesLast = _ref.loadCxStylesLast;

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isThemeLoaded = _React$useState2[0],
      setIsThemeLoaded = _React$useState2[1];

  var _React$useState3 = _react.default.useState(),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      currentTheme = _React$useState4[0],
      setCurrentTheme = _React$useState4[1];

  var currentThemeRegistry = (0, _mergeRegistry.default)(themeRegistries);
  (0, _initializeThemeRegistry.default)(currentThemeRegistry);
  (0, _cxObserver.default)();

  _react.default.useEffect(function () {
    (0, _initializeSelectedTheme.default)(themeName, currentThemeRegistry, setCurrentTheme);
  }, [themeName]); // wait for the current them to get resolved during the initializeSelectedTheme


  if (currentTheme && !isThemeLoaded) {
    (0, _gtag.default)("event", "CXThemeProvider", {
      cx_version: _cxThemeInfo.cxuiversion,
      cx_theme: currentTheme,
      cx_application_name: document.title || window.location.href
    });
    (0, _setSelectedTheme.default)(currentTheme, null);
    var selectedTheme = (0, _getSelectedTheme.default)();
    var themeToLoad = (0, _getThemeFromRegistry.default)(selectedTheme, currentThemeRegistry);

    if (themeToLoad && themeToLoad.themeLoader) {
      themeToLoad.themeLoader(setIsThemeLoaded, loadCxStylesLast);
    }
  }

  if (isThemeLoaded) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  }

  return null;
};

CxThemeProvider.propTypes = propTypes;
var _default = CxThemeProvider;
exports.default = _default;